import PublisherActions from '../../../../actions/PublisherActions';
import CurrencyActions from '../../../../actions/CurrencyActions';
import CustomNotify from '../../../Notify';
import UserStore from '../../../../stores/UserStore';

export const actions = {
    savePaymentAccount(params, success, error) {
        let action = params.currentPaymentId ? 'edit' : 'create';
        let apiMethod = action + 'PaymentAccount';

        let validParams = {
            id: params.currentPaymentId ? params.currentPaymentId : false,
            paymentSystemId: params.paymentSystemId,
            bankAccount: params.bankAccount,
            bankName: params.bankName,
            bic: params.bic,
            currency: params.currency,
            cardNumber: params.cardNumber,
            cryptoCurrency: params.cryptoCurrency,
            cryptoNetwork: params.cryptoNetwork,
            description: params.description,
            edrpouIpn: params.edrpouIpn,
            fullName: params.fullName,
            iban: params.iban,
            purposeOfPayment: params.purposeOfPayment,
            title: params.title
        };

        CurrencyActions.savePaymentAccount(apiMethod, validParams).then((data) => {
            if (!data.error) {
                PublisherActions.getPaymentDetails();

                const notyNames = UserStore.getTranslation().notyMessages;
                const keyMessage = action === 'edit' ? 'update' : 'add';
                CustomNotify(notyNames[keyMessage]);

                success && success();
            } else {
                error && error(data.error.invalid_parameters);
            }
        });
    }
};
